// Logotype логотип для главного экрана
export function Logotype() {
    const style = "flex justify-center items-center p-1 md:p-2 border-solid border rounded-md " +
        "uppercase h-[26px] w-[26px] md:h-[32px] md:w-[32px] bg-yellow-400 border-yellow-500 text-yellow-800 font-bold text-sm md:text-base";
    return (
        <div className={"flex w-full justify-center items-center z-10"}>
            <div className={"flex flex-col md:flex-row w-full gap-[2px] md:gap-1"}>
                <div className={"flex gap-[2px] md:gap-1"}>
                    <div className={style}>С</div>
                    <div className={style}>л</div>
                    <div className={style}>о</div>
                    <div className={style}>в</div>
                    <div className={style}>а</div>
                    <div className={style}>р</div>
                    <div className={style}>и</div>
                    <div className={style}>у</div>
                    <div className={style}>м</div>
                </div>
            </div>
        </div>
    );
}
